import React from "react";
import "./Divider.css";
const DividerIcon = require("../../resources/images/icons/divider.svg").default;

function Divider() {
    return (
        <div className="divider">
            <img src={DividerIcon}></img>
        </div>
    );
}

export default Divider;
